import { useState, useMemo } from 'react';
import type { Transaction } from '../../types';
import { useTransactions } from '../../hooks/useTransactions';
import { SkeletonTable } from '../../components/ui';
import WasteClaimsView from '../../components/tabs/WasteClaimsView';
import OverrideTransactionModal from '../../components/OverrideTransactionModal';

interface Props {
  caseId: string;
}

export default function InvestigationWaste({ caseId }: Props) {
  const { data: transactions = [], isLoading } = useTransactions(caseId);
  const [overrideTxn, setOverrideTxn] = useState<Transaction | null>(null);

  const wasteTransactions = useMemo(
    () => transactions.filter((t) => t.waste_flag),
    [transactions],
  );
  const totalWasteAmount = useMemo(
    () => wasteTransactions.reduce((sum, t) => sum + Math.abs(t.amount), 0),
    [wasteTransactions],
  );

  if (isLoading) {
    return <SkeletonTable rows={6} columns={5} />;
  }

  return (
    <>
      <WasteClaimsView
        caseId={caseId}
        transactions={transactions}
        wasteTransactions={wasteTransactions}
        totalWasteAmount={totalWasteAmount}
        onOverride={setOverrideTxn}
      />
      <OverrideTransactionModal txn={overrideTxn} onClose={() => setOverrideTxn(null)} />
    </>
  );
}
